@import "../../../../../../../../../shared/styles/base";

$highlight-before: linear-gradient(to right, transparent, transparent 50%, $ds-violet-100 50%, $ds-violet-100);
$highlight-all: $ds-violet-100;
$highlight-after: linear-gradient(to right, $ds-violet-100, $ds-violet-100 50%, transparent 50%, transparent);

.c-calendar-day {
  position: relative;
  margin: 0.125rem 0;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  outline: none;
  appearance: none;
  border: none;
  background: none;
  user-select: none;

  &__label {
    position: relative;
    font-size: $ds-font-size-b5;
    display: flex;
    height: 2rem;
    width: 2rem;
    border-radius: 100%;
    align-items: center;
    justify-content: center;
  }

  &.is-today &__label {
    color: $ds-violet-500;
    font-weight: $ds-font-weight-medium;

    &::after {
      content: "";
      position: absolute;
      bottom: 0.5rem;
      left: 0.7rem;
      right: 0.7rem;
      border-bottom: 1px solid $ds-violet-500;
    }
  }

  &:not(.is-current-month) &__label {
    display: none;
  }

  &.is-in-range:not(.is-outside-month) {
    background-color: $ds-violet-100;
  }

  &.is-start-date &__label,
  &.is-end-date &__label {
    background-color: $ds-violet-500;
    color: white;
  }

  &.is-current-month:not(.is-disabled):hover {
    cursor: pointer;
  }

  &.is-current-month:not(.is-disabled, .is-start-date, .is-end-date):hover &__label,
  &.is-current-month:not(.is-disabled, .is-start-date, .is-end-date):focus &__label {
    border: 2px solid $ds-violet-500;
    background-color: $white;
  }

  &.is-current-month:not(.is-disabled):hover &__label::after {
    border: none;
  }

  &.is-in-range.is-start-date,
  &.is-in-range.is-end-date {
    background: none;
  }

  &.is-selected &__label {
    background-color: $ds-violet-500;
    color: $white;
  }

  &.is-disabled {
    opacity: 0.5;
  }

  &.is-outside-month {
    opacity: 0;
    visibility: hidden;
  }
}

// The highlights for the selected range depend on some classes from higher up the DOM, so:
.c-calendar {
  .c-calendar-day {
    &.is-in-range {
      background: $highlight-all;
    }

    &.is-start-date {
      background: $highlight-before;
    }

    &.is-end-date {
      background: $highlight-after;
    }

    &.is-start-date.is-end-date {
      background: $white;
    }

    &:hover:not(.is-start-date, .is-end-date) .c-calendar-day__label {
      border: 2px solid $ds-violet-500;
      background-color: $white;
      color: $black;
    }
  }
}
